var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.email)?_c('span',{staticClass:"user-teams-link inline-block"},[_c('teams-logo',{attrs:{"height":"21","width":"21","inline":""}}),_c('a',{staticClass:"ml-3",attrs:{"href":`https://teams.microsoft.com/l/chat/0/0?users=${_vm.email}`}},[_vm._t("default",function(){return [_vm._v("Contact me on Teams")]})],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }